import * as XLSX from 'xlsx';

export function extractNormalizedHeaders(worksheet) {
  const headers = {};
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  const headerRow = range.s.r;

  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: headerRow, c: col });
    const cellValue = worksheet[cellAddress]?.v?.toString().trim();
    if (cellValue) {
      headers[cellValue.toLowerCase()] = col;
    }
  }

  return headers;
}

export function getColumnIndexByName(headers, columnName) {
  return headers[columnName.trim().toLowerCase()] ?? -1;
}

export function normalize(value) {
  return typeof value === 'string' ? value.trim() : value;
}

export function findMissingColumns(headers, requiredColumns) {
  return requiredColumns.filter(
    (col) => !Object.keys(headers).includes(col.trim().toLowerCase())
  );
}

export function isValidURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

export function getFormattedTimestamp() {
  const now = new Date();
  const pad = (num) => String(num).padStart(2, '0');

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1);
  const year = now.getFullYear();

  let hours = now.getHours();
  const minutes = pad(now.getMinutes());
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12; // Convert to 12-hour format
  const time = `${hours}:${minutes} ${ampm}`;

  return `${day}${month}${year} ${time}`;
}

